const discourseUserChatabilityCache = new Map<string, { value: boolean; cachedAt: number }>();
const discourseUserChatabilityInFlight = new Map<string, Promise<boolean>>();
const CHATABILITY_CACHE_TTL_MS = 60 * 1000;

export const fetchDiscourseUserChatability = async (username: string, forceRefresh = false): Promise<boolean> => {
  const cacheKey = username.toLowerCase();
  const cached = discourseUserChatabilityCache.get(cacheKey);
  const isCacheFresh = cached && (Date.now() - cached.cachedAt) < CHATABILITY_CACHE_TTL_MS;

  if (!forceRefresh && isCacheFresh) {
    return cached.value;
  }

  const inFlight = discourseUserChatabilityInFlight.get(cacheKey);
  if (!forceRefresh && inFlight) {
    return inFlight;
  }

  const request = fetch(`/api/discourse/user/${encodeURIComponent(username)}`, {
    cache: 'no-store',
  })
    .then(async (response) => {
      if (!response.ok) {
        let errorMessage = 'Failed to fetch user chatability';
        try {
          const data = await response.json();
          if (data && typeof data === 'object' && typeof (data as any).error === 'string') {
            errorMessage = (data as any).error;
          }
        } catch {
          // Ignore JSON parsing errors and use the generic error message.
        }
        throw new Error(errorMessage);
      }

      const data = await response.json();
      return Boolean(data?.chatable ?? (data?.forum_active && !data?.suspended));
    })
    .finally(() => {
      discourseUserChatabilityInFlight.delete(cacheKey);
    });

  discourseUserChatabilityInFlight.set(cacheKey, request);

  const canChat = await request;
  discourseUserChatabilityCache.set(cacheKey, { value: canChat, cachedAt: Date.now() });

  return canChat;
};
